import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneSubject from '../ones/OneSubject';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import SubjectRegistrationForm from "../ones/SubjectRegistrationForm";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);	

	const [searchFilter, setSearchFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await appContext.getAllSubjects();
		setReady(true);
	}

	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		//..
	}, [appContext.allSubjects])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && appContext.allSubjects) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							Subjects
						</h6>
					</div>

					<div className="col-12 col-md-12">
						<div
							className="card"
						>
							<div className="card-body">
								<h6
									className="sub-section-title"
								>
									Register New Subject
								</h6>
								<hr/>

								<SubjectRegistrationForm/>
								
							</div>
						</div>
					</div>

					<div className="col-md-12" id="_coinsOrdersList">
						<div
							className="card"
						>
							<div className="card-body">

								<div className="d-flex justify-content-between mb-4">

									<h6
										className="sub-section-title"
										
									>
										All Subjects
									</h6>

									<input
										className="form-control mNoMargin align-self-center"
										style={{
											width: "150px"
										}}
										onChange={(e) => setSearchFilter(e.target.value)}
										placeholder="Filter by name"
									/>

								</div>
								<hr/>

								{
									(appContext.allSubjects && appContext.allSubjects.length > 0) ?
										appContext.allSubjects.map((item, i) => {
											if (searchFilter) {
												if (
													String(item.name).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 
												) {
													return (
														<OneSubject data={item} key={i} />
													)
												} else {
													return "";
												}
											} else {
												return (
													<OneSubject data={item} key={i} />
												)
											}
										})
										:
										<h6
											className=""
											style={{
												fontSize: "14px",
											}}
										>
											No subject was found
										</h6>
								}
							</div>

						</div>
					</div>

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}